<script setup lang="ts">
  import { useTranslation } from '@/composables/useTranslation'
  import { AlertCircle, RotateCcw } from 'lucide-vue-next'

  defineProps<{
    error: string
  }>()

  defineEmits<{
    (e: 'retry'): void
  }>()

  const { t } = useTranslation({
    en: {
      retry: 'Try again',
      defaultError: 'Something went wrong. Please try again.'
    },
    de: {
      retry: 'Erneut versuchen',
      defaultError: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
    },
    fr: {
      retry: 'Réessayer',
      defaultError: "Une erreur s'est produite. Veuillez réessayer."
    }
  })
</script>

<template>
  <div class="flex flex-col items-start gap-3 self-stretch rounded-lg bg-red-50 p-3">
    <div class="flex items-start gap-2">
      <AlertCircle
        class="mt-0.5 h-4 w-4 flex-shrink-0 text-red-500"
        :stroke-width="1.5"
      />
      <p class="text-sm font-normal leading-5 text-red-700 font-inter">
        {{ error || t('defaultError') }}
      </p>
    </div>
    <button
      type="button"
      class="inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-sm font-medium text-red-700 transition
        hover:bg-red-100"
      @click="$emit('retry')"
    >
      <RotateCcw
        class="h-3.5 w-3.5"
        :stroke-width="1.5"
      />
      {{ t('retry') }}
    </button>
  </div>
</template>
